import React, {useEffect, useState} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { serverDomain } from "../../config";
import "./login.css";

const Header = () => (
    <header className="header">
        <div className="logo">
            <span>Fl-Dating</span>
        </div>
    </header>
);

function getCookie(name) {
    const m = document.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/[$()*+./?[\\\]^{|}-]/g, '\\$&') + '=([^;]*)')
    );
    return m ? decodeURIComponent(m[1]) : null;
}

const Register = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        telegram: "",
        traffic_source: "",
        average_daily: "",
        hear_about_us: "",
        ref: ""
    });
    const [message, setMessage] = useState("");
    const [telegramError, setTelegramError] = useState(""); // Ошибка формата Telegram


    const location = useLocation();
    useEffect(() => {
           const params = new URLSearchParams(location.search);
           const fromUrl = params.get("ref");
           const fromStorage = localStorage.getItem("ref_code") || localStorage.getItem("ref");
           const fromCookie = getCookie("ref");
           const ref = (fromUrl || fromStorage || fromCookie || "").trim();
           if (ref) {
             setFormData(prev => ({ ...prev, ref }));
           }
        }, [location.search]);


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });

        // Проверка формата Telegram в реальном времени
        if (e.target.name === "telegram") {
            const value = e.target.value;
            if (!/^@\w+$/.test(value)) {
                setTelegramError("Telegram должен начинаться с @ и содержать user_id.");
            } else {
                setTelegramError("");
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (
            !formData.name.trim() ||
            !formData.email.trim() ||
            !formData.password.trim() ||
            !formData.confirmPassword.trim() ||
            !formData.telegram.trim() ||
            !formData.traffic_source.trim() ||
            !formData.average_daily.trim() ||
            !formData.hear_about_us.trim()
        ) {
            setMessage("Заполните все поля");
            return;
        }

        if (formData.password !== formData.confirmPassword) {
            setMessage("Пароли не совпадают");
            return;
        }
        try {
            const res = await axios.post(`${serverDomain}/api/auth/register`, formData);
            setMessage(
                res.data.message ||
                "Мы отправили вам письмо со ссылкой для подтверждения. Перейдите по ссылке из письма."
            );

        } catch (error) {
            setMessage(error.response?.data?.message || "Ошибка регистрации");
        }
    };

    const handleLogin = () => {
        navigate("/login"); // Переход на страницу входа
    };

    return (
        <div className={"auth-page"}>
            <Header />
            <div className="login-container">
            <h2 style={{fontWeight: "bold", marginBottom: "12px", fontSize: "20px"}}>Регистрация</h2>
            <form onSubmit={handleSubmit}>
                <input type="text" name="name" placeholder="Имя" value={formData.name} onChange={handleChange} required />
                <input type="email" name="email" placeholder="E-mail" value={formData.email} onChange={handleChange} required />
                <input type="password" name="password" placeholder="Пароль" value={formData.password} onChange={handleChange} required />
                <input type="password" name="confirmPassword" placeholder="Повторите пароль" value={formData.confirmPassword} onChange={handleChange} required />
                <input
                    type="text"
                    name="telegram"
                    placeholder="@username (пример: @user123)"
                    value={formData.telegram}
                    onChange={handleChange}
                    required
                />
                {telegramError && <p style={{ color: "red" }}>{telegramError}</p>}
                <textarea name="traffic_source" placeholder="Расскажите о ваших источниках трафика" value={formData.traffic_source} onChange={handleChange} required />
                <textarea name="average_daily" placeholder="Какие у вас средние объемы в день" value={formData.average_daily} onChange={handleChange} required />
                <textarea name="hear_about_us" placeholder="Откуда узнали о нас" value={formData.hear_about_us} onChange={handleChange} required />
                <button type="submit">Зарегистрироваться</button>
                <button
                    type="button"
                    className="secondary"
                    onClick={handleLogin}
                >
                    Войти
                </button>
                {message && <p style={{color: 'red'}}>{message}</p>}
            </form>

            </div>
        </div>
    );
};

export default Register;
